module.exports = __webpack_public_path__ + "static/bullet-train-30b97e219440212d56c924ce4ed2df70.png";